var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-echart',{staticClass:"tree-echart",attrs:{"id":_vm.treeId,"width":_vm.width,"height":_vm.height,"option":_vm.option}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }